import axios from 'axios';

import { parentRefreshTokenRequest } from '../parentAuth.api';
import { getParentAccessToken, getParentAuthState, getParentRefreshToken, saveParentAuth } from '../../utils/tokenStorage';

const parentApi = axios.create({
  baseURL: process.env.REACT_APP_PARENT_API_URL || '',
  headers: {
    Accept: 'application/json',
  },
});

// Attach access token
parentApi.interceptors.request.use((config) => {
  const token = getParentAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// Retry on 401
parentApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = getParentRefreshToken();
        if (!refreshToken) return Promise.reject(error);

        const res = await parentRefreshTokenRequest(refreshToken);

        // Save new tokens
        saveParentAuth({
          access_token: res.data.access_token,
          refresh_token: res.data.refresh_token,
          user: getParentAuthState().user,
        });

        // Retry original request
        originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;
        return parentApi(originalRequest);
      } catch (err) {
        localStorage.removeItem('parent_access_token');
        localStorage.removeItem('parent_refresh_token');
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

export default parentApi;
